import React, { ChangeEvent } from "react";

export type AppIconProps = {
  active?: boolean;
  name: string;
  className?: string;
  size?: string;
  margin?: string;
  title?: string;
  onClick?: (event: ChangeEvent<HTMLSelectElement>) => void;
  onMouseDown?: (event: ChangeEvent<HTMLSelectElement>) => void;
  style?: React.CSSProperties;
} & React.ComponentProps<"span">;

const AppIcon = ({
  active,
  name,
  className,
  size,
  margin,
  onClick,
  onMouseDown,
  title,
  ...props
}: AppIconProps) => {
  const classesStatut = active ? "icon-style-active" : "icon-style-inactive";
  const iconClasses = "icon-" + name;
  const classes = `${iconClasses} ${className} ${classesStatut}`;
  return (
    <span
      title={title}
      className={classes}
      style={{
        ...props.style,
        fontSize: size ? size : "32px",
        margin: margin ? margin : "0 auto",
        backgroundColor: "transparent",
      }}
      onClick={onClick}
      onMouseDown={onMouseDown}
    />
  );
};

export default AppIcon;
